import React from "react";
import style from "./OrderInfoMobileActions.module.scss";
import ClientActionsTab from "./components/client/ClientActionsTab";
import ExpeditorActionsTab from "./components/expeditor/ExpeditorActionsTab";

const OrderInfoMobileActions = ({
  order,
  cargoDetails,
  statusHistory = [],
  fetchOrderData,
  onForceUpdate,
  refreshDocuments,
  onClose,
  user,
  company,
  listSuggestedPrice = [],
  complexTenderPrices = [],
  driverPrices = [],
  complexTenderBids = [],
}) => {
  if (!order) return null;

  if (user?.type === "Client") {
    return (
      <div className={style.wrapper}>
        <ClientActionsTab
          order={order}
          cargoDetails={cargoDetails}
          fetchOrderData={fetchOrderData}
          onForceUpdate={onForceUpdate}
          statusHistory={statusHistory}
          listSuggestedPrice={listSuggestedPrice}
          complexTenderPrices={complexTenderPrices}
          driverPrices={driverPrices}
          complexTenderBids={complexTenderBids}
          onClose={onClose}
        />
      </div>
    );
  }

  if (user?.type === "Expeditor" || order.companyId !== company?.id) {
    return (
      <div className={style.wrapper}>
        <ExpeditorActionsTab
          order={order}
          cargoDetails={cargoDetails}
          statusHistory={statusHistory}
          fetchOrderData={fetchOrderData}
          onForceUpdate={onForceUpdate}
          refreshDocuments={refreshDocuments}
          onClose={onClose}
        />
      </div>
    );
  }

  return null;
};

export default OrderInfoMobileActions;
